import { CrudFilters } from "../../../../hooks/useCrudFilters";
import { Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { TableFilters } from "../../../general/table/modules/commons/tableFilters/tableFilters";
import { TableFilterInputWrapper } from "../../../general/table/modules/commons/tableFilters/tableFilters";
import { TableFiltersWrapper } from "../../../general/table/modules/commons/tableFilters/tableFilters";

export const RelationTableFilters = ({
  updateFilter,
  removeFilter,
  getFilter,
  filters,
  resetFilters,
}: CrudFilters) => {
  const searchValue = getFilter("name", "contains") as string;
  const statusValue = getFilter("status");
  const { t } = useTranslation("common");

  return (
    <TableFiltersWrapper>
      <TableFilters>
        <TableFilterInputWrapper md={6}>
          <label>{t("Search")}</label>
          <Form.Control
            type="text"
            placeholder={t("Search by name")}
            value={searchValue ?? ""}
            onChange={(event) => {
              const value = event.target.value;
              if (value === "") {
                removeFilter("name");
              } else {
                updateFilter("name", value, "contains");
              }
            }}
          />
        </TableFilterInputWrapper>

        <TableFilterInputWrapper md={6}>
          <label>{t("Status")}</label>
          <Form.Select
            onChange={(event) => {
              const value = event.target.value;
              if (value === "") {
                removeFilter("status");
              } else {
                updateFilter("status", value === "1");
              }
            }}
            value={`${statusValue ?? ""}`}
          >
            <option value={""}>{"- " + t("All") + " -"}</option>
            <option value={0}>{t("Inactive")}</option>
            <option value={1}>{t("Active")}</option>
          </Form.Select>
        </TableFilterInputWrapper>
      </TableFilters>

      {filters?.fields && Object.keys(filters.fields).length > 0 && (
        <Button
          onClick={resetFilters}
          size={"sm"}
          className="reset-filters"
          variant="light"
        >
          {t("Reset filters")}
        </Button>
      )}
    </TableFiltersWrapper>
  );
};
